import { create } from "zustand";

/**
 * The firm workspace a house user is currently acting in. A house Team Leader or
 * staffer defaults to the in-house (CAP) book and switches into an assigned
 * Business-Practitioner firm from the sidebar; the selection then scopes the
 * Clients, Practitioners, and New-Arrivals pages until they switch back.
 *
 * Kept in-memory (not persisted): it survives SPA navigation but resets to
 * In-house on a full reload, so it can never leak across a login.
 */
interface FirmContextState {
  /** The active BP firm id, or undefined when acting on the in-house book. */
  activeFirmId?: string;
  /** Display name of the active firm (shown in the banner / switcher). */
  activeFirmName?: string;
  setActiveFirm: (id: string, name: string) => void;
  clearFirm: () => void;
}

export const useFirmContextStore = create<FirmContextState>((set) => ({
  activeFirmId: undefined,
  activeFirmName: undefined,
  setActiveFirm: (id, name) => set({ activeFirmId: id, activeFirmName: name }),
  clearFirm: () => set({ activeFirmId: undefined, activeFirmName: undefined }),
}));
